module.exports = __webpack_public_path__ + "004.df560395.png";